export const NO_RESULTS_MESSAGE = "No results";
